import axios from "axios";
import { getLocalStorageItem, tokensConstant } from "./LocalStorage.js";
import { baseUrl } from "../config/app.config";
import store from "../Store/store";
import { toasterModel, toasterColor } from "../Models/ToasterModel";

export const axiosInterceptorSetup = () => {
  axios.defaults.headers.common["Content-Type"] = "application/json";
  axios.interceptors.request.use((req) => {
    var accessToken = getLocalStorageItem(tokensConstant.AccessToken);
    store.commit("toggleLoading", true);
    if (accessToken != null) {
      req.headers.common.Authorization = "Bearer " + accessToken;
    }

    if (req.headers.noheaders) {
      debugger;
      delete req.headers.common.Authorization;
      delete req.headers.noheaders;
    }

    return req;
  });

  axios.interceptors.response.use(
    (response) => {
      store.commit("toggleLoading", false);
      return response;
    },
    (error) => {
      store.commit("toggleLoading", false);
      let originalRequest = error.config;
      if (
        error.response.status === 401 &&
        originalRequest.url == baseUrl + "/api/Login/reauthenticate"
      ) {
        store.dispatch("logOffUser");
        store.commit(
          "toaster",
          toasterModel(
            "Session Expired !! Please Login To Continue",
            toasterColor.error
          )
        );
        return Promise.reject(error);
      }

      if (error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;

        return new Promise((resolve, reject) => {
          var refreshToken = getLocalStorageItem(tokensConstant.RefreshtToken);
          axios
            .get(baseUrl + "/api/Login/reauthenticate", {
              headers: { Authorization: `Bearer ${refreshToken}` },
            })
            .then((response) => {
              if (response.status == 200) {
                store.dispatch("authenticateUser", response.data);
                store.dispatch("getAreaBranchTeamService");
                originalRequest.headers["Authorization"] =
                  "Bearer " + response.data.AccessToken;
                resolve(axios(originalRequest));
              }
            });
        });
      }
      // return Error object with Promise
      return Promise.reject(error);
    }
  );
};
